import { HIGHLIGHTED_STATE, SELECTED_STATE } from 'store/filters/constants';
import {
  canAddNode,
  GetNodeSelectionStyles,
  getSize,
  IsObjectEmpty,
} from './graph-helper';
import {
  RELATIONSHIP_TYPE_FAMILY,
  RELATIONSHIP_TYPE_CHARITABLE,
  RELATIONSHIP_TYPE_EDUCATION,
  RELATIONSHIP_TYPE_ENGAGEMENT,
  RELATIONSHIP_TYPE_ATTENDED,
  RELATIONSHIP_TYPE_ORGANIZATIONAL,
  RELATIONSHIP_TYPE_PERSONAL,
} from 'store/graph/constants';
import { getClusterableAffiliation as getClusterableAffiliationShared } from './affiliation';

export const contextSpecificFilters = (
  items,
  nodes,
  links,
  hiddenNodes,
  contexts,
  contextFilters,
  nodesAlreadyStyled = {},
) => {
  for (const contextId in contextFilters) {
    const context = contexts[contextId];
    const contextFiltersForId = contextFilters[contextId];
    const { edgeFilters, removeEdges } =
      contextFiltersForId.edgeFilters.filtersForEdges;
    const nodeFiltersEnabled =
      contextFiltersForId.edgeFilters.nodeOptions.length > 0 ||
      contextFiltersForId.edgeFilters.nodeTypeFilterOut.length > 0;
    const isRegionsFilterEmpty = IsObjectEmpty(
      contextFiltersForId.nodeFilters.regions,
    );
    const constitencies = Object.keys(
      contextFiltersForId.nodeFilters.constituency,
    );
    const { nodeFilterType, nodeTypeFilterOut, nodeOptions, nodeSizingType } =
      contextFiltersForId.edgeFilters;
    const isConstituenciesEmpty = constitencies.length < 1;

    // add nodes from links
    if (context) {
      for (const index in context.linkIds) {
        const linkId = context.linkIds[index];
        const graphLink = links[linkId]?.link;
        if (
          removeEdges.length > 0 &&
          isEdgeIncluded(
            graphLink,
            removeEdges,
            contextFiltersForId.edgeFilters.timeFilters,
          )
        ) {
          return;
        }

        const [nodeOneId, nodeTwoId] = linkId.split('/p/');
        const nodeOne = nodes[nodeOneId]?.node;
        const nodeTwo = nodes[nodeTwoId]?.node;
        if (edgeFilters.length < 1) {
          // if no edge filters, show normal node graph
          const addedNodeOne = addNode(
            nodeOne,
            items,
            nodeOneId,
            nodeFiltersEnabled,
            nodeFilterType,
            nodeTypeFilterOut,
            nodeOptions,
            nodeSizingType,
            constitencies,
            isRegionsFilterEmpty,
            isConstituenciesEmpty,
            contextFiltersForId.nodeFilters,
            hiddenNodes,
          );
          const addedNodeTwo = addNode(
            nodeTwo,
            items,
            nodeTwoId,
            nodeFiltersEnabled,
            nodeFilterType,
            nodeTypeFilterOut,
            nodeOptions,
            nodeSizingType,
            constitencies,
            isRegionsFilterEmpty,
            isConstituenciesEmpty,
            contextFiltersForId.nodeFilters,
            hiddenNodes,
          );

          // add link only if both nodes added
          if (addedNodeOne && addedNodeTwo) {
            const { data, ...newLinkToAdd } = graphLink;
            items[linkId] = newLinkToAdd;
          }
        } else {
          if (
            contextFiltersForId.edgeFilters.edgeFilterType === HIGHLIGHTED_STATE
          ) {
            // filterType is selected state
            const isIncluded = isEdgeIncluded(
              graphLink,
              edgeFilters,
              contextFiltersForId.edgeFilters.timeFilters,
              true,
            );
            if (isIncluded) {
              const addedNodeOne = addNode(
                nodeOne,
                items,
                nodeOneId,
                nodeFiltersEnabled,
                nodeFilterType,
                nodeTypeFilterOut,
                nodeOptions,
                nodeSizingType,
                constitencies,
                isRegionsFilterEmpty,
                isConstituenciesEmpty,
                contextFiltersForId.nodeFilters,
                hiddenNodes,
                nodesAlreadyStyled,
                false,
                true,
              );
              const addedNodeTwo = addNode(
                nodeTwo,
                items,
                nodeTwoId,
                nodeFiltersEnabled,
                nodeFilterType,
                nodeTypeFilterOut,
                nodeOptions,
                nodeSizingType,
                constitencies,
                isRegionsFilterEmpty,
                isConstituenciesEmpty,
                contextFiltersForId.nodeFilters,
                hiddenNodes,
                nodesAlreadyStyled,
                false,
                true,
              );
              if (addedNodeOne && addedNodeTwo) {
                const { data, ...newGraphLink } = {
                  ...graphLink,
                  color: graphLink.activeColor,
                };
                items[linkId] = newGraphLink;
              }
            } else {
              const addedNodeOne = addNode(
                nodeOne,
                items,
                nodeOneId,
                nodeFiltersEnabled,
                nodeFilterType,
                nodeTypeFilterOut,
                nodeOptions,
                nodeSizingType,
                constitencies,
                isRegionsFilterEmpty,
                isConstituenciesEmpty,
                contextFiltersForId.nodeFilters,
                hiddenNodes,
              );
              const addedNodeTwo = addNode(
                nodeTwo,
                items,
                nodeTwoId,
                nodeFiltersEnabled,
                nodeFilterType,
                nodeTypeFilterOut,
                nodeOptions,
                nodeSizingType,
                constitencies,
                isRegionsFilterEmpty,
                isConstituenciesEmpty,
                contextFiltersForId.nodeFilters,
                hiddenNodes,
              );
              if (addedNodeOne && addedNodeTwo) {
                const { data, ...newGraphLink } = graphLink;
                items[linkId] = newGraphLink;
              }
            }
          } else {
            // filterType is selected state
            const isIncluded = isEdgeIncluded(
              graphLink,
              edgeFilters,
              contextFiltersForId.edgeFilters.timeFilters,
            );
            if (isIncluded) {
              const addedNodeOne = addNode(
                nodeOne,
                items,
                nodeOneId,
                nodeFiltersEnabled,
                nodeFilterType,
                nodeTypeFilterOut,
                nodeOptions,
                nodeSizingType,
                constitencies,
                isRegionsFilterEmpty,
                isConstituenciesEmpty,
                contextFiltersForId.nodeFilters,
                hiddenNodes,
                true,
              );
              const addedNodeTwo = addNode(
                nodeTwo,
                items,
                nodeTwoId,
                nodeFiltersEnabled,
                nodeFilterType,
                nodeTypeFilterOut,
                nodeOptions,
                nodeSizingType,
                constitencies,
                isRegionsFilterEmpty,
                isConstituenciesEmpty,
                contextFiltersForId.nodeFilters,
                hiddenNodes,
                true,
              );
              if (addedNodeOne && addedNodeTwo) {
                const { data, ...newGraphLink } = {
                  ...graphLink,
                  color: graphLink.activeColor,
                };
                items[linkId] = newGraphLink;
              }
            }
          }
        }
      }
    }
  }
};

export const isEdgeIncluded = (
  graphLink,
  edgeFilters,
  timefilters,
  isRemoval = false,
) => {
  const connectionValue = graphLink?.data?.connection;
  const connectionType = graphLink?.data?.connectionType;
  const isIncluded = edgeFilters.includes(connectionValue);
  if (isIncluded) {
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_FAMILY) {
      const { familyOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        familyOptionsTimeFilter.start,
        familyOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_PERSONAL) {
      const { professionalOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        professionalOptionsTimeFilter.start,
        professionalOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_ORGANIZATIONAL) {
      const { organizationalOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        organizationalOptionsTimeFilter.start,
        organizationalOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_CHARITABLE) {
      const { charitableOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        charitableOptionsTimeFilter.start,
        charitableOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_EDUCATION) {
      const { educationOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        educationOptionsTimeFilter.start,
        educationOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_ENGAGEMENT) {
      const { engagementOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        engagementOptionsTimeFilter.start,
        engagementOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
    if (graphLink?.data?.connectionType === RELATIONSHIP_TYPE_ATTENDED) {
      const { attendedOptionsTimeFilter } = timefilters;
      return getTimeFilterIsIncluded(
        attendedOptionsTimeFilter.start,
        attendedOptionsTimeFilter.end,
        graphLink,
        isRemoval,
      );
    }
  }
  return false;
};

export const getTimeFilterIsIncluded = (start, end, graphLink, isRemoval) => {
  if (start === null && end === null) {
    return true;
  }
  if (!isRemoval) {
    if (start !== null) {
      const startdate = graphLink?.data?.startdate;
      if (startdate === undefined) {
        return false;
      }
      const graphStartDate = new Date(startdate);
      if (graphStartDate < new Date(start)) {
        return false;
      }
    }
    if (end !== null) {
      const enddate = graphLink?.data?.enddate;
      if (enddate === undefined) {
        return false;
      }
      const graphEndDate = new Date(enddate);
      if (graphEndDate > new Date(end)) {
        return false;
      }
    }
  } else {
    if (start !== null) {
      const startdate = graphLink?.data?.startdate;
      if (startdate !== undefined) {
        const graphStartDate = new Date(startdate);
        if (graphStartDate < new Date(start)) {
          return false;
        }
      }
    }
    if (end !== null) {
      const enddate = graphLink?.data?.enddate;
      if (enddate !== undefined) {
        const graphEndDate = new Date(enddate);
        if (graphEndDate > new Date(end)) {
          return false;
        }
      }
    }
  }
  // if none apply return true;
  return true;
};

// Affiliation parsing is shared (audit S10 / H17) — see src/utils/affiliation.js.
const getClusterableAffiliation = getClusterableAffiliationShared;

// Per-node memoization (S5).
//
// Most filter / context churn changes one or two inputs but invalidates every
// item in the dict. Keying on the underlying `node` reference + a small
// composite of the inputs that *actually* feed buildNodeItem lets identical
// inputs return the same object reference, which then short-circuits the
// transform cache and the setElements diff downstream.
//
// WeakMap entries are GC'd when the source node is removed from the graph,
// so this cache is bounded to live nodes.
const _itemCache = new WeakMap();

const buildNodeItem = (sourceNode, size, nodeData) => {
  const affUnit = nodeData?.affliationUnit ?? '';
  // Cache key includes only the inputs that influence the result. `nodeData`
  // is currently only `{ affliationUnit }` (or undefined), so we collapse it
  // to that single string.
  const key = `${size}|${affUnit}`;
  let perNode = _itemCache.get(sourceNode);
  if (perNode) {
    const hit = perNode.get(key);
    if (hit) return hit;
  } else {
    perNode = new Map();
    _itemCache.set(sourceNode, perNode);
  }

  const result = {};
  const keys = Object.keys(sourceNode);
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    if (k !== 'data') result[k] = sourceNode[k];
  }
  result.size = size;
  if (nodeData) result.data = nodeData;

  perNode.set(key, result);
  return result;
};


/**
 * Creates a pre-computed filter context object to avoid passing 16+ parameters repeatedly.
 * Call this once before the main loop, then pass `filterCtx` to `addNodeCtx`.
 */
export const createFilterCtx = ({
  nodeFiltersEnabled,
  nodeFilterType,
  nodeTypeFilterOut,
  nodeOptions,
  nodeSizingType,
  constitencies,
  isRegionsFilterEmpty,
  isConstituenciesEmpty,
  nodeFilters,
  hiddenNodes,
  affiliationClusterMode = false,
}) => {
  const selectedAffiliations = nodeFilters?.affiliation || {};
  const selectedAffiliationKeys = Object.keys(selectedAffiliations).map(k => k.toLowerCase());

  return {
    nodeFiltersEnabled,
    nodeFilterType,
    nodeTypeFilterOut,
    nodeOptions,
    nodeSizingType,
    constitencies,
    isRegionsFilterEmpty,
    isConstituenciesEmpty,
    nodeFilters,
    hiddenNodes,
    affiliationClusterMode,
    selectedAffiliationKeys,
    // Pre-compute Sets for O(1) lookup when arrays are large enough to matter
    nodeTypeFilterOutSet: nodeTypeFilterOut.length > 8 ? new Set(nodeTypeFilterOut) : null,
    nodeOptionsSet: nodeOptions.length > 8 ? new Set(nodeOptions) : null,
  };
};

// Fast inclusion check using Set when available, falling back to Array.includes
const includesCheck = (arr, set, value) => set ? set.has(value) : arr.includes(value);

/**
 * Optimized addNode that accepts a pre-computed filterCtx object instead of 16 separate params.
 */
export const addNodeCtx = (
  node,
  items,
  nodeId,
  filterCtx,
  nodesAlreadyStyled = {},
  edgeSelected = false,
  useAlreadyStyled = false,
) => {
  // Early return: node already in items (and already styled if required)
  if (
    items[nodeId] !== undefined &&
    (useAlreadyStyled ? nodesAlreadyStyled[nodeId] !== undefined : true)
  ) {
    return true;
  }

  const {
    nodeFiltersEnabled,
    nodeFilterType,
    nodeTypeFilterOut,
    nodeTypeFilterOutSet,
    nodeOptions,
    nodeOptionsSet,
    nodeSizingType,
    constitencies,
    isRegionsFilterEmpty,
    isConstituenciesEmpty,
    nodeFilters,
    hiddenNodes,
    affiliationClusterMode,
    selectedAffiliationKeys,
  } = filterCtx;

  const nodeType = node?.data?.nodeType;

  // Early bailout: if node filters are enabled and this node type is definitely excluded,
  // skip the expensive canAddNode check entirely.
  if (nodeFiltersEnabled) {
    if (nodeFilterType === HIGHLIGHTED_STATE) {
      if (includesCheck(nodeTypeFilterOut, nodeTypeFilterOutSet, nodeType)) return false;
    } else if (nodeFilterType === SELECTED_STATE) {
      if (!includesCheck(nodeOptions, nodeOptionsSet, nodeType)) return false;
    } else {
      if (includesCheck(nodeTypeFilterOut, nodeTypeFilterOutSet, nodeType)) return false;
    }
  }

  const canAdd = canAddNode(
    node,
    isRegionsFilterEmpty,
    isConstituenciesEmpty,
    constitencies,
    nodeFilters,
    hiddenNodes,
    affiliationClusterMode,
  );

  if (!canAdd) return false;

  const size = getSize(nodeSizingType, node?.data);
  const clusterAffiliation = getClusterableAffiliation(node?.data?.affliationUnit, selectedAffiliationKeys, affiliationClusterMode);
  const nodeData = clusterAffiliation ? { affliationUnit: clusterAffiliation } : undefined;

  const markStyled = () => {
    if (useAlreadyStyled) nodesAlreadyStyled[nodeId] = nodeId;
  };

  if (nodeFiltersEnabled) {
    if (nodeFilterType === HIGHLIGHTED_STATE) {
      // Already checked !isNodeFilteredOut above
      const isNodeIncludedInOptions = includesCheck(nodeOptions, nodeOptionsSet, nodeType);
      if (isNodeIncludedInOptions) {
        const selectionStyles = GetNodeSelectionStyles(node);
        // Merge node + selectionStyles, then strip data
        const merged = Object.assign({}, node, selectionStyles);
        items[nodeId] = buildNodeItem(merged, size, nodeData);
      } else {
        items[nodeId] = buildNodeItem(node, size, nodeData);
      }
      markStyled();
      return true;
    } else if (nodeFilterType === SELECTED_STATE) {
      // Already checked isNodeIncludedInOptions above
      const selectionStyles = GetNodeSelectionStyles(node);
      const merged = Object.assign({}, node, selectionStyles);
      items[nodeId] = buildNodeItem(merged, size, nodeData);
      markStyled();
      return true;
    } else {
      // Already checked !isNodeFilteredOut above
      items[nodeId] = buildNodeItem(node, size, nodeData);
      markStyled();
      return true;
    }
  } else {
    // No node filters
    if (edgeSelected) {
      const selectionStyles = GetNodeSelectionStyles(node);
      const merged = Object.assign({}, node, selectionStyles);
      items[nodeId] = buildNodeItem(merged, size, nodeData);
    } else {
      items[nodeId] = buildNodeItem(node, size, nodeData);
    }
    markStyled();
    return true;
  }
};

// Legacy addNode kept for backward compatibility with contextSpecificFilters
export const addNode = (
  node,
  items,
  nodeId,
  nodeFiltersEnabled,
  nodeFilterType,
  nodeTypeFilterOut,
  nodeOptions,
  nodeSizingType,
  constitencies,
  isRegionsFilterEmpty,
  isConstituenciesEmpty,
  nodeFilters,
  hiddenNodes,
  nodesAlreadyStyled = {},
  edgeSelected = false,
  useAlreadyStyled = false,
  affiliationClusterMode = false,
) => {
  const filterCtx = createFilterCtx({
    nodeFiltersEnabled,
    nodeFilterType,
    nodeTypeFilterOut,
    nodeOptions,
    nodeSizingType,
    constitencies,
    isRegionsFilterEmpty,
    isConstituenciesEmpty,
    nodeFilters,
    hiddenNodes,
    affiliationClusterMode,
  });
  return addNodeCtx(node, items, nodeId, filterCtx, nodesAlreadyStyled, edgeSelected, useAlreadyStyled);
};
